import { ownerEnvironment as betaEnvironment } from './environments/environment.beta';
import { ownerEnvironment as devEnvironment } from './environments/environment.dev';
import { ownerEnvironment as prodEnvironment } from './environments/environment.prod';
import { ownerEnvironment as baseEnvironment } from './environments/environment';

export const appConfig = {
  applicationId: 'owner',

  beta: {
    apiUrl: betaEnvironment.apiUrl,
    beta: betaEnvironment.beta,
    enableMedicalRecordsV2: betaEnvironment.enableMedicalRecordsV2,
  },

  dev: {
    apiUrl: devEnvironment.apiUrl,
    development: devEnvironment.development,
    enableMedicalRecordsV2: devEnvironment.enableMedicalRecordsV2,
  },

  prod: {
    apiUrl: prodEnvironment.apiUrl,
    production: prodEnvironment.production,
    enableMedicalRecordsV2: prodEnvironment.enableMedicalRecordsV2,
  },

  apiUrl: baseEnvironment.apiUrl,
  enableMedicalRecordsV2: baseEnvironment.enableMedicalRecordsV2,
};